import { SxProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const ModelComponentsStyle = {
  dialogSx: {
    padding: "0px !important",
    overflowX: "hidden",
    ".css-1ty026z": { p: "0px !important" },
    ".css-ypiqx9-MuiDialogContent-root": { p: "0px !important" },
    ".MuiDialog-paper": {
      m: {
        xs: "16px !important",
        md: "32px !important",
      },
      width: { xs: "100% !important", sm: "calc(100% - 64px);" },
    },
    ".MuiPaper-rounded": {
      borderRadius: "12px",
      padding: { xs: "24px 16px", sm: "32px 40px 24px 40px" },
      backgroundColor: `${muiVariables.primaryColor}`,
    },
  } as SxProps,
};

export default ModelComponentsStyle;
